import { __awaiter } from "tslib";
import { status } from '@/alas';
import { setting } from '@/storage';
import { showError } from '@/store';
import { defineComponent, watch, ref } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let vueitfy = context.root.$vuetify;
        // ================
        //
        // refs
        //
        let user = ref(status.fetch('user'));
        // ================
        //
        // watch
        //
        watch(() => vueitfy.theme.dark, () => setting.setDark(vueitfy.theme.dark));
        // ================
        //
        // methods
        //
        let signOut = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield user.value.$o.signOut.start();
            }
            catch (error) {
                showError(error);
            }
        });
        // ================
        //
        // done
        //
        return {
            user,
            signOut
        };
    }
});
